<template>
  <div class="dealership-phone" :brand="brand" :class="brand.name">
    Sales:
    <a :href="`tel:${salesPhoneCompact}`" id="sales-number" class="dealership-url" :class="brand.name" v-on:click="trackClickSalesPhone">
      {{ dealer.phone.sales | phoneFormatter }}
    </a>
    &nbsp;&#124;&nbsp;Service:
    <a :href="`tel:${servicePhoneCompact}`" id="service-number" class="dealership-url" :class="brand.name" v-on:click="trackClickServicePhone">
      {{ dealer.phone.service | phoneFormatter }}
    </a>
  </div>
</template>

<script>
import { phoneFormatter } from '@/utils/filters'
export default {
  name: 'DealerPhone',
  props: {
    brand: Object,
    dealer: Object
  },
  computed: {
    salesPhoneCompact () {
      return phoneFormatter(this.dealer.phone.sales, 'compact')
    },
    servicePhoneCompact () {
      return phoneFormatter(this.dealer.phone.service, 'compact')
    }
  },
  methods: {
    trackClickSalesPhone () {
      this.$store.dispatch('track/gaEvent', { vm: this, category: 'phone', action: 'click', label: 'sales' })
      this.$store.dispatch('track/facebookEvent', { event: 'Phone-Click-Sales' })
    },
    trackClickServicePhone () {
      this.$store.dispatch('track/gaEvent', { vm: this, category: 'phone', action: 'click', label: 'service' })
      this.$store.dispatch('track/facebookEvent', { event: 'Phone-Click-Service' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dealership-url {
  color: var(--url-color);
  text-decoration: none;
}
.dealership-phone {
  font-size: 14px;
  line-height: 1.2em;
  display: inline-block;
}
.dealership-url.bmw,
.dealership-url.subaru  {
  color: var(--banner-text-color);
  text-decoration: none;
}
.dealership-font-size {
  font-size: 14px;
}
.dealership-phone.jaguar,
.dealership-phone.land-rover {
  font-size: 11px;
}

/*small device responsive style*/
@media only screen and (min-width: 576px) {
  .dealership-font-size {
    font-size: 12px;
  }
}
/*medium device responsive style*/
@media only screen and (min-width: 768px) {
}
/*large device responsive style*/
@media only screen and (min-width: 992px) {
}
/*extra large device responsive style*/
@media only screen and (min-width: 1200px) {
  .dealership-font-size {
    font-size: 14px;
  }
}
</style>
